/**
 * 认领状态
 * 
 * @Author: Focci
 * @Date: 2023-09-20 13:56:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-20 13:56:29
 */

import useApp from '@hook/useApp'
import { useState, useEffect } from 'react'

export default function useTrackStatus(propertyId) {
  const [ready, setReady] = useState(false)
  const { subcribes, setSubcribes, isInitial } = useApp()

  useEffect(() => { !isInitial && setReady(true) }, [isInitial])

  function removeSubcribe() {
    setSubcribes((prev) => prev.filter((id) => id !== propertyId))
  }

  return {
    ready,
    removeSubcribe,
    isTracked: subcribes.indexOf(propertyId) > -1,
  }
}
